function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.56285 20H20.6171C20.8189 20 21.0096 19.9178 21.1516 19.7757C21.2937 19.6336 21.3685 19.4393 21.3647 19.2374C21.275 14.6878 18.1685 10.8299 13.9928 9.58505C15.3984 8.64673 16.3255 7.04673 16.3255 5.23364C16.3255 2.34766 13.9778 0 11.0918 0C8.20585 0 5.85818 2.34766 5.85818 5.23364C5.85818 7.04673 6.78528 8.64673 8.18715 9.58505C4.01145 10.8336 0.904911 14.6878 0.815191 19.2374C0.811453 19.4393 0.889957 19.6336 1.02828 19.7757C1.16659 19.9178 1.36472 20 1.56285 20ZM7.35351 5.23364C7.35351 3.17383 9.03201 1.49533 11.0918 1.49533C13.1516 1.49533 14.8301 3.17383 14.8301 5.23364C14.8301 7.29346 13.1516 8.97196 11.0918 8.97196C9.03201 8.97196 7.35351 7.29346 7.35351 5.23364ZM11.0918 10.6542C15.5853 10.6542 19.3535 14.1121 19.8245 18.5047H2.35912C2.83014 14.1121 6.59837 10.6542 11.0918 10.6542Z",
  fill: "white"
});

function SvgHeaderProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderProfile);
export default __webpack_public_path__ + "static/media/header_profile.ac4ccf4a.svg";
export { ForwardRef as ReactComponent };